/// \file securityRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";
import securityUsers from "./securityUsers";
import securityLogs from "./securityLogs";
import securityLockouts from "./securityLockouts";
import securityRoles from "./securityRoles";
import securityAdminEvents from "./securityAdminEvents";

const routes = (
  <Route
    path="security"
    handle={{
      text: 'Security'
    }}
  >
    {securityUsers}
    {securityLogs}
    {securityRoles}
    {securityLockouts}
    {securityAdminEvents}
  </Route>
);

export default routes;